import { IFrame, IFramePermission } from "client/Components";
import {
	generateEmbedUrl as generateVimeoEmbedUrl,
	getInfoFromVimeoUrl,
	isVimeoVideoUrl,
	VimeoVideoInfo
} from "client/Misc/vimeo";
import {
	generateEmbedUrl as generateYoutubeEmbedUrl,
	getIdFromYoutubeUrl,
	isYoutubeVideoUrl
} from "client/Misc/youTube";
import { ReactElement } from "react";
import styles from "./Video.module.less";

export type VideoProps = {
	url: string;
};

export const Video = (props: VideoProps): ReactElement => {
	const { url } = props;

	return (

		<div className={styles.video}>
			<VideoViewer url={url}	/>
		</div>
	);
};
Video.displayName = "ContentLayout.Video";

export type VideoViewerProps = {
	url: string;
};

export const VideoViewer = (props: VideoViewerProps): ReactElement | null => {
	const { url } = props;

	let videoElement: ReactElement | null = null;

	if (isYoutubeVideoUrl(url)) {
		const videoId: TryResult<string> = getIdFromYoutubeUrl(url);

		if (!videoId.wasSuccessful) {
			return null;
		}

		videoElement = (
			<IFrame
				className={styles.iframe}
				frameBorder="0"
				allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
				allowFullScreen
				src={generateYoutubeEmbedUrl({
					videoId: videoId.result
				})}
				trackingId="youtube-iframe"
				permissions={videoIframePermissions}
			/>
		);
	} else if (isVimeoVideoUrl(url)) {
		const videoInfo: TryResult<VimeoVideoInfo> = getInfoFromVimeoUrl(url);

		if (!videoInfo.wasSuccessful) {
			return null;
		}

		videoElement = (
			<IFrame
				className={styles.iframe}
				frameBorder="0"
				allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
				allowFullScreen
				src={generateVimeoEmbedUrl(videoInfo.result)}
				trackingId="vimeo-iframe"
				permissions={videoIframePermissions}
			/>
		);
	}

	return (
		<div className={styles.videoContent}>
			{videoElement}
		</div>
	);
};
VideoViewer.displayName = "VideoViewer";

export const videoIframePermissions: readonly IFramePermission[] = [
	IFramePermission.Downloads,
	IFramePermission.Forms,
	IFramePermission.Modals,
	IFramePermission.OrientationLock,
	IFramePermission.PointerLock,
	IFramePermission.Popups,
	IFramePermission.EscapingPopups,
	IFramePermission.Presentation,
	IFramePermission.SameOrigin,
	IFramePermission.Scripts
];
